import React, { useCallback } from 'react'
import Demo, { CrashPage } from '../components/Demo/Demo'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { axiosInstance } from '../axios/publicAxios'
import { useState } from 'react'
import { useEffect } from 'react'
import { useRef } from 'react'
import { toast } from 'react-toastify'

const DemoPage = () => {
  const isLoggedIn = useSelector((state)=>state.authState.isLoggedIn)
  const user = useSelector((state)=>state.authState.user)
  const [status, setStatus] = useState('checking')
  const hasChecked = useRef(false)

  const resetSession = useCallback(() => {
      toast.dismiss()
      localStorage.removeItem("user")
      localStorage.removeItem("isLoggedIn")
      localStorage.setItem("logout-event", Date.now())
  },[])

  const verifyDemoSession = useCallback(async () => {
    if (!(isLoggedIn && user?.isDemoUser)) {
      setStatus('inactive')
      return
    }
    try {
      await axiosInstance.post('/demo-entry/status', {}, { withCredentials: true })
      setStatus('active')
    }
    catch (err) {
      if (err.response?.status === 401){
        resetSession()
        setStatus('inactive')
      }
      else{
        setStatus('crash')
      }
    }
  },[isLoggedIn,user?.isDemoUser,resetSession])

  useEffect(() => {
    if (hasChecked.current) return
    hasChecked.current = true
    verifyDemoSession()
  }, [verifyDemoSession])

  return (
    status === "active" ? <Navigate to = "/notes"/> :
    (status === "checking" || status === "inactive") ? <Demo status = {status}/> :
    status === "crash" && <CrashPage handleRetry = {()=>verifyDemoSession()}/>
  )
}

export default DemoPage